import React from 'react';
import { FmlxButton } from 'fmlx-common-ui';
import 'App.css';

function RMButton({
  onClick,
  customStyle = null,
  Icon = null,
  disabled = false,
  className = '',
  ...rest
}) {
  return (
    <FmlxButton
      id="controls-rmbutton-wrapper"
      data-testid="controls-rmbutton-wrapper"
      style={{
        background: '#008F40',
        color: '#ffffff',
        display: 'flex',
        height: '2rem',
        textTransform: 'uppercase',
        minHeight: '2rem',
        maxHeight: '2rem',
        fontSize: '1rem',
        borderRadius: '0.375rem',
        width: '4.125rem',
        ...customStyle,
      }}
      className={className}
      onClick={onClick}
      icon={Icon}
      disabled={disabled}
      {...rest}
    ></FmlxButton>
  );
}

export default RMButton;
